import { render, staticRenderFns } from "./UpsertBusinessUnitModal.vue?vue&type=template&id=0322774e&"
import script from "./UpsertBusinessUnitModal.vue?vue&type=script&lang=ts&"
export * from "./UpsertBusinessUnitModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports